import { SET_SEARCH_NOTIFY, CLEAR_SEARCH_NOTIFY } from "../actions";

const INITIAL_STATE = {
  label: "",
  items: []
};

export default function searchNotify(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_SEARCH_NOTIFY:
      return {
        label: action.payload.label,
        items: action.payload.items
      };
    case CLEAR_SEARCH_NOTIFY:
      return INITIAL_STATE;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/searchNotify.js